export default __webpack_public_path__ + "static/media/DCP-Logo-Light.6957e8c8.png";